import { LockedCard } from "@/components/layout/locked-content";
import { message } from "@/lib/utils";

export function PlatformAdaptation() {
  return <LockedCard title="Platform Adaptation" message={message} />;
}
